module.exports = __webpack_public_path__ + "static/img/roland_ph_03.cc05233.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/recruit/2025/top/company/roland_ph_03.png
// module id = caGI
// module chunks = 0